import React, { useEffect } from 'react';
import '../styles/WhyUsPage.css';
import pic_2 from '../assets/stock-2.png'
import pic_4 from '../assets/stock-4.png'
import pic_5 from '../assets/stock-5.png'
import pic_7 from '../assets/stock-7.png'
import pic_9 from '../assets/stock-9.jpg'
import pic_10 from '../assets/stock-10.jpg'
import img_1 from '../assets/image4.jpg'


const WhyUsPage: React.FC = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="why-us-page py-10 p-8 md:p-12">
      <div className="page-header">
        <h2 className="text-4xl md:text-5xl font-bold animate-fade-in">
          Why Us?
        </h2>
      </div>

      {/* Metrics Section */}
      <div className="metrics-section">
        <div className="metrics-container">
          <div className="metric-item">
            <div className="metric-value">97%</div>
            <div className="metric-label">Client Satisfaction</div>
          </div>
          <div className="metric-item">
            <div className="metric-value">150+</div>
            <div className="metric-label">Projects Delivered</div>
          </div>
          <div className="metric-item">
            <div className="metric-value">12+</div>
            <div className="metric-label">Years Experience</div>
          </div>
          <div className="metric-item">
            <div className="metric-value">24/7</div>
            <div className="metric-label">Support</div>
          </div>
        </div>
      </div>

  <div className="why-us-container-why-page">
    <div className="why-us-cards">
    {/* Item 1 - Image Left / Content Right */}
    <div className="why-us-card timeline-item">
      <div className="timeline-image">
        <img src={img_1} 
           alt="Disaster recovery" />
      </div>
      <div className="why-us-content-wrapper">
        <div className="why-us-card-header">
          <div className="why-us-icon-wrapper">
            <div className="why-us-icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
              </svg>
            </div>
          </div>
          <h3 className="why-us-title">Instant "Disaster-Proof" Recovery</h3>
        </div>
        <div className="why-us-content-why-page">
          <p className="why-us-text">
          When a critical failure strikes—say, your network configuration is accidentally erased—Betaque's recovery process rebuilds your entire environment in under an hour. No more frantically piecing together manual steps at 3 AM; you'll be back online before most of your team's morning coffee.
          </p>
        </div>
      </div>
    </div>

    {/* Item 2 - Image Right / Content Left */}
    <div className="why-us-card timeline-item reverse">
      <div className="why-us-content-wrapper">
        <div className="why-us-card-header">
          <div className="why-us-icon-wrapper">
            <div className="why-us-icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 4v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4"></path>
                <line x1="12" y1="15" x2="12" y2="3"></line>
                <polyline points="17 8 12 3 7 8"></polyline>
              </svg>
            </div>
          </div>
          <h3 className="why-us-title">Approve a Change, See It Live</h3>
        </div>
        <div className="why-us-content-why-page">
          <p className="why-us-text">
          Instead of juggling manual updates and hoping nothing breaks, every infrastructure change goes through a simple review-and-approve flow. Once you greenlight it, our system applies the update automatically, so you can be confident that what's tested in staging looks the same in production.
          </p>
        </div>
      </div>
      <div className="timeline-image">
        <img src={pic_2}
             alt="Change approval" />
      </div>
    </div>

    {/* Item 3 - Image Left / Content Right */}
    <div className="why-us-card timeline-item">
      <div className="timeline-image">
      <img src={pic_10} alt="Compliance audit" />
      </div>
      <div className="why-us-content-wrapper">
        <div className="why-us-card-header">
          <div className="why-us-icon-wrapper">
            <div className="why-us-icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
              </svg>
            </div>
          </div>
          <h3 className="why-us-title">Pass Audits Before Breakfast</h3>
        </div>
        <div className="why-us-content-why-page">
          <p className="why-us-text">
          Compliance shouldn't be a scramble. We embed validation checks into your processes so that every component meets your regulatory requirements before it exists. When auditors arrive, you'll hand over a clear report proving everything was vetted ahead of time—no scrambling or last-minute fixes.
          </p>
        </div>
      </div>
    </div>

    {/* Item 4 - Image Right / Content Left */}
    <div className="why-us-card timeline-item reverse">
      <div className="why-us-content-wrapper">
        <div className="why-us-card-header">
          <div className="why-us-icon-wrapper">
            <div className="why-us-icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" 
                viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="3" width="20" height="6" rx="2" ry="2" />
                <rect x="2" y="9" width="20" height="6" rx="2" ry="2" />
                <rect x="2" y="15" width="20" height="6" rx="2" ry="2" />
                <path d="M12 9v-5" />
                <path d="M9 6l3-3 3 3" />
              </svg>
            </div>
          </div>
          <h3 className="why-us-title">Effortless Scaling During Peak Demand </h3>
            
        </div>
        <div className="why-us-content-why-page">
          <h5>( Scale from 0 to 1000 Nodes Without a Second Thought )</h5>
          <p className="why-us-text">
          Whether you're launching a new feature or running a limited-time promotion, your platform adjusts capacity automatically—no manual intervention. You'll stay online at your busiest moments, without worrying about sudden traffic spikes or performance hiccups.
          </p>
        </div>
      </div>
      <div className="timeline-image">
        <img src={pic_4} 
             alt="Change approval" />
      </div>
    </div>

    {/* Item 5 - Image Left / Content Right */}
    <div className="why-us-card timeline-item">
      <div className="timeline-image">
        <img src={pic_5}
         alt="Compliance audit" />
      </div>
      <div className="why-us-content-wrapper">
        <div className="why-us-card-header">
          <div className="why-us-icon-wrapper">
            <div className="why-us-icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" 
              viewBox="0 0 24 24" fill="none" stroke="currentColor" 
              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17.5 19H9a7 7 0 1 1 6.71-9"/>
              <circle cx="18" cy="18" r="3"/>
              <path d="M18 15v1"/>
              <path d="M18 21v1"/>
              <path d="M21 18h-1"/>
              <path d="M15 18h-1"/>
              <path d="M16.5 16.5l.5.5"/>
              <path d="M19.5 19.5l.5.5"/>
              <path d="M19.5 16.5l-.5.5"/>
              <path d="M16.5 19.5l-.5.5"/>
            </svg>
            </div>
          </div>
          <h3 className="why-us-title">One Management Approach for All Clouds</h3>
        </div>
        <div className="why-us-content-why-page">
          <p className="why-us-text">
          If you run workloads across multiple cloud providers, Betaque lets you handle everything consistently from a single framework. You decide which provider suits each task, and our solution ensures you don't have to re-create or reconfigure environments to make it happen.
          </p>
        </div> 
      </div>
    </div>

    {/* Item 6 - Image Right / Content Left */}
    <div className="why-us-card timeline-item reverse">
      <div className="why-us-content-wrapper">
        <div className="why-us-card-header">
          <div className="why-us-icon-wrapper">
            <div className="why-us-icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" 
              viewBox="0 0 24 24" fill="none" stroke="currentColor" 
              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14.7 6.3a5 5 0 0 0-6.4 6.4l-5 5a2 2 0 1 0 2.8 2.8l5-5a5 5 0 0 0 6.4-6.4l-2.1 2.1" />
            </svg>
            </div>
          </div>
          <h3 className="why-us-title">Free Your Engineers to Build, Not Break Stuff </h3>
            
        </div>
        <div className="why-us-content-why-page">
          <p className="why-us-text">
          Your development team no longer needs to spend 70 % of their time on routine upkeep—patching, updates, or environment provisioning. Betaque automates those mundane tasks behind the scenes, freeing your engineers to build features, not fight infrastructure fires.
          </p>
        </div>
      </div>
      <div className="timeline-image">
        <img src={pic_9}
             alt="Change approval" />
      </div>
    </div>

       {/* Item 7 - Image Left / Content Right */}
    <div className="why-us-card timeline-item">
      <div className="timeline-image">
      <img src={pic_7} alt="Compliance audit" />
      </div>
      <div className="why-us-content-wrapper">
        <div className="why-us-card-header">
          <div className="why-us-icon-wrapper">
            <div className="why-us-icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" 
                viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>

            </div>
          </div>
          <h3 className="why-us-title">Sleep Soundly on Weekends</h3>
        </div>
        <div className="why-us-content-why-page">
          <p className="why-us-text">
          When the workday ends—whether it's a Friday night or a holiday—you can relax knowing that any alert will trigger a proven response plan, not a frantic all-hands call. With Betaque's playbooks and training, your team handles incidents swiftly and confidently, so you actually get to enjoy your downtime.
          </p>
        </div>
      </div>
    </div>


  </div>
</div>

      {/* Our Process Section */}
      <div className="process-section">
        <h2 className="section-title">Our Process</h2>
        <p className="why-us-section-subtitle">A streamlined approach to delivering exceptional results</p>
        
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">01</div>
            <div className="step-content">
              <h3 className="step-title">Discovery</h3>
              <p className="step-description">
                We begin by understanding your business, objectives, and challenges through collaborative 
                workshops and in-depth discussions to ensure perfect alignment.
              </p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">02</div>
            <div className="step-content">
              <h3 className="step-title">Strategy & Planning</h3>
              <p className="step-description">
                Our team develops a comprehensive roadmap, defining the scope, technology stack, architecture, 
                and delivery timeline tailored to your specific requirements.
              </p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">03</div>
            <div className="step-content">
              <h3 className="step-title">Design & Development</h3>
              <p className="step-description">
                Using agile methodologies, we bring your solution to life with iterative development cycles, 
                regular check-ins, and continuous improvement based on feedback.
              </p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">04</div>
            <div className="step-content">
              <h3 className="step-title">Testing & Quality Assurance</h3>
              <p className="step-description">
                Our rigorous QA process ensures your solution meets the highest standards of performance, 
                security, and user experience before deployment.
              </p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">05</div>
            <div className="step-content">
              <h3 className="step-title">Deployment & Support</h3>
              <p className="step-description">
                We handle seamless deployment and provide ongoing maintenance and support to ensure your 
                solution continues to perform optimally and evolves with your needs.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="tech-expertise-section">
        <h2 className="tech-section-title">Our Technology Expertise</h2>
        <p className="tech-section-subtitle">Comprehensive solutions across the entire technology spectrum</p>
        
        <div className="tech-cards">
          {/* DevOps */}
          <div className="tech-card">
            <div className='tech-heading'>
              <div className="tech-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 20V10"></path>
                  <path d="M12 20V4"></path>
                  <path d="M6 20v-6"></path>
                </svg>
              </div>
              <h3 className="tech-title">DevOps</h3>
            </div>
            <p className="tech-description">
              Streamline your development pipeline with our DevOps expertise. We implement CI/CD pipelines, 
              infrastructure as code, and automated testing to accelerate delivery and improve reliability.
            </p>
          </div>

          {/* Cloud Services */}
          <div className="tech-card">
            <div className='tech-heading'>
              <div className="tech-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"></path>
                </svg>
              </div>
              <h3 className="tech-title">Cloud Services</h3>
            </div>  
            <p className="tech-description">
              Leverage the full potential of AWS, Azure, and GCP with our cloud-native solutions. We design 
              scalable, secure, and cost-effective cloud architectures tailored to your specific needs.
            </p>
          </div>

          {/* Full Stack Development */}
          <div className="tech-card">
            <div className='tech-heading'>
              <div className="tech-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M8 3v3a2 2 0 0 1-2 2H3"></path>
                  <path d="M21 8h-3a2 2 0 0 1-2-2V3"></path>
                  <path d="M3 16h3a2 2 0 0 1 2 2v3"></path>
                  <path d="M16 21v-3a2 2 0 0 1 2-2h3"></path>
                </svg>
              </div>
              <h3 className="tech-title">Full Stack Development</h3>
            </div>
            <p className="tech-description">
              From frontend interfaces to backend systems, we deliver cohesive solutions using modern frameworks 
              and languages. Our full stack expertise ensures smooth integration between all components.
            </p>
          </div>

          {/* Mobile Development */}
          <div className="tech-card">
            <div className='tech-heading'>
              <div className="tech-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                  <path d="M12 18h.01"></path>
                </svg>
              </div>
              <h3 className="tech-title">Mobile Apps (iOS & Android)</h3>
            </div>
            <p className="tech-description">
              Create exceptional mobile experiences with our iOS and Android development services. 
              We build native and cross-platform applications that are fast, intuitive, and feature-rich.
            </p>
          </div>

          {/* Web Applications */}
          <div className="tech-card">
            <div className='tech-heading'>
              <div className="tech-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                  <path d="M21 15l-5-5L5 21"></path>
                </svg>
              </div>
              <h3 className="tech-title">Web Applications</h3>
            </div>
            <p className="tech-description">
              Develop modern, responsive web applications that deliver exceptional user experiences. 
              Our web development expertise spans React, Angular, Vue, and other leading frameworks.
            </p>
          </div>

          {/* Enterprise Applications */}
          <div className="tech-card">
            <div className='tech-heading'>
              <div className="tech-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"></path>
                  <path d="M18 14h-8"></path>
                  <path d="M15 18h-5"></path>
                  <path d="M10 6h8v4h-8V6Z"></path>
                </svg>
              </div>
              <h3 className="tech-title">Enterprise Solutions</h3>
            </div>
            <p className="tech-description">
              Build robust, scalable enterprise applications that drive business growth. Our solutions 
              integrate seamlessly with your existing systems while providing advanced functionality.
            </p>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="testimonials-section">
        <h2 className="section-title">What Our Clients Say</h2>
        <p className="why-us-section-subtitle">Success stories from businesses we've helped transform</p>
        
        <div className="testimonials-container">
          <div className="testimonial">
            <div className="testimonial-content">
              <p className="testimonial-text">
                "Betaque transformed our outdated systems into a modern, scalable platform that has dramatically 
                improved our operational efficiency. Their technical expertise and client-focused approach made 
                them the perfect partner for our digital transformation journey."
              </p>
            </div>
            <div className="testimonial-author">
              <div className="author-avatar">
                <span>JD</span>
              </div>
              <div className="author-info">
                <h4 className="author-name">John Doe</h4>
                <p className="author-title">CTO, Enterprise Solutions Inc.</p>
              </div>
            </div>
          </div>
          
          <div className="testimonial">
            <div className="testimonial-content">
              <p className="testimonial-text">
                "The mobile application developed by Betaque has received outstanding feedback from our users. 
                Their development process was transparent, and they consistently delivered on time and within 
                budget. We couldn't be happier with the results."
              </p>
            </div>
            <div className="testimonial-author">
              <div className="author-avatar">
                <span>SJ</span>
              </div>
              <div className="author-info">
                <h4 className="author-name">Sarah Johnson</h4>
                <p className="author-title">Product Manager, TechInnovate</p>
              </div>
            </div>
          </div>
          
          <div className="testimonial">
            <div className="testimonial-content">
              <p className="testimonial-text">
                "Betaque's cloud migration strategy saved us significant operational costs while improving 
                our system's performance and reliability. Their team's deep expertise in cloud services and 
                DevOps has been invaluable to our business growth."
              </p>
            </div>
            <div className="testimonial-author">
              <div className="author-avatar">
                <span>RM</span>
              </div>
              <div className="author-info">
                <h4 className="author-name">Robert Miller</h4>
                <p className="author-title">CEO, Cloud Solutions Ltd</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="why-us-footer">
        <p className="why-us-footer-text">
          Choose Betaque for a partner that combines technical excellence with a genuine commitment to your success. 
          Our innovative approach, efficiency, and deep expertise make us the ideal choice for organizations 
          seeking to transform their digital presence and capabilities.
        </p>
        <div className="why-us-cta">
          <a href="#contact" className="why-us-cta-button">
            Start Your Journey With Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default WhyUsPage; 